import React,{Fragment, PureComponent, } from 'react'
import {Image, message,} from 'antd';
import PropTypes from 'prop-types';
import Lang from "@/components/Lang/Lang";
import ShipperManagementAction from "../ShipperManagement.action";

const ImagePreviewGroup= Image.PreviewGroup;
/**
 * 查看贴纸排版图组件 点击打开，幻灯片模式，
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 *
 **/
class StickerPicturePreview extends PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
    }
    static defaultProps = {
        item: {},
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            list: [],
        }
    }
    /**
     * 查看贴纸排版图
     * */
    viewStickerPictures(poItem={}){
        if(poItem.poId){
            this.props.loading(true);
            const postData = {
                poId:poItem.poId,
            }
            ShipperManagementAction.getStickerLayoutList(postData).then(res=>this.handleGetPicturesRes(res.data)).catch(err=>this.handleGetPicturesRes(err));
        }else message.warning(Lang({
            id:'CaoZuoShiBai',
            default:'操作失败'
        }));
    }
    handleGetPicturesRes(res){
        this.props.loading(false);
        const {success,valid,models=[]} = res;
        if(success&&valid){
           if(models.length>0){
               this.setVisible(true,models)
           }else message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({
            id:'CaoZuoShiBai',
            default:'操作失败'
        }));
    }
    /**
     * 设置 预览
     */
    setVisible(flag,models=[],current=0){
        this.setState({
            visible:flag,
            list:models,
            current:current
        })
    }
    componentDidMount() {
      if(this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { item,} = this.props;
        const { visible, current,list }=this.state;
        return (<Fragment>
            <a onClick={() => this.viewStickerPictures(item,true,1)} className={"color-blue"}>
                {Lang({id: 'ChaKanTieZhiPaiBanTu', default: '查看贴纸排版图'})}
            </a>
            <div style={{ display: 'none' }}>
                <ImagePreviewGroup preview={{ visible, current, onVisibleChange: vis => this.setVisible(vis) }}>
                    {list.map(src=><Image src={src.fileUrl} key={src.fileId} />)}
                </ImagePreviewGroup>
            </div>
        </Fragment>);
    }
}

export default StickerPicturePreview;
